import React, { useState } from "react";
import { Droppable } from "@hello-pangea/dnd";
import { FaEllipsisH, FaPlus } from "react-icons/fa";

import TaskKanbanCard from "./TaskKanbanCard";

export default function TaskKanbanColumn({
  column,
  onOpenTask,
  onCreateInColumn,
  onToggleDone,
  onDuplicate,
  onArchive,
  onDelete,
  allCardsExpanded,
  expandedTaskIds,
  onToggleTaskExpanded,
}) {
  const [menuOpen, setMenuOpen] = useState(false);

  const columnColor = column.color || column.label_color || "#38bdf8";
  const subtitle = column.subtitle || (column.mode === "status" ? "Statut" : "Application");

  return (
    <section className="flex max-h-[calc(100vh-225px)] w-[312px] shrink-0 cursor-default flex-col overflow-hidden rounded-3xl border border-white/25 bg-slate-100/95 text-[#172b4d] shadow-2xl backdrop-blur">
      <header className="relative flex min-h-[58px] items-center justify-between gap-2 border-b border-slate-200/80 bg-white/70 px-3 py-3">
        <div
          className="absolute inset-x-0 top-0 h-2"
          style={{ backgroundColor: columnColor }}
        />

        <button
          type="button"
          className="min-w-0 pt-1 text-left"
          onClick={() => onCreateInColumn(column)}
        >
          <h2 className="truncate text-sm font-bold leading-tight">
            {column.title}
          </h2>
          <p className="mt-0.5 text-[11px] font-semibold uppercase tracking-wide text-slate-400">
            {subtitle}
          </p>
        </button>

        <div className="flex items-center gap-1 pt-1">
          <span className="rounded-full bg-slate-900 px-2 py-0.5 text-xs font-bold text-white">
            {column.count || 0}
          </span>

          <div className="relative">
            <button
              type="button"
              onClick={() => setMenuOpen((current) => !current)}
              className="grid h-8 w-8 place-items-center rounded-xl text-slate-500 transition hover:bg-slate-200 hover:text-slate-800"
            >
              <FaEllipsisH />
            </button>

            {menuOpen && (
              <div className="absolute right-0 top-9 z-20 w-52 rounded-2xl border border-slate-200 bg-white p-2 text-sm shadow-2xl">
                <button
                  type="button"
                  onClick={() => {
                    setMenuOpen(false);
                    onCreateInColumn(column);
                  }}
                  className="flex w-full items-center gap-2 rounded-xl px-3 py-2 text-left font-bold text-slate-700 hover:bg-slate-100"
                >
                  <FaPlus />
                  Ajouter une tâche
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      <Droppable droppableId={column.id}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={`min-h-[20px] flex-1 overflow-y-auto px-2.5 py-3 transition ${
              snapshot.isDraggingOver ? "bg-sky-100/90" : ""
            }`}
          >
            <div className="space-y-2.5">
              {(column.tasks || []).map((task, index) => {
                const isExpanded =
                  allCardsExpanded || expandedTaskIds?.has(String(task.id));

                return (
                  <TaskKanbanCard
                    key={task.id}
                    task={task}
                    index={index}
                    expanded={isExpanded}
                    onToggleExpanded={onToggleTaskExpanded}
                    onOpenTask={onOpenTask}
                    onToggleDone={onToggleDone}
                    onDuplicate={onDuplicate}
                    onArchive={onArchive}
                    onDelete={onDelete}
                  />
                );
              })}

              {provided.placeholder}

              {(column.tasks || []).length === 0 && (
                <div className="rounded-2xl border border-dashed border-slate-300 bg-white/60 px-3 py-7 text-center text-sm text-slate-400">
                  Glisse une tâche ici
                </div>
              )}
            </div>
          </div>
        )}
      </Droppable>

      <footer className="border-t border-slate-200/80 bg-white/65 px-2.5 py-2">
        <button
          type="button"
          onClick={() => onCreateInColumn(column)}
          className="flex h-10 w-full items-center justify-center gap-2 rounded-2xl px-3 text-sm font-bold text-slate-600 transition hover:bg-slate-200 hover:text-slate-900"
        >
          <FaPlus />
          Ajouter une tâche
        </button>
      </footer>
    </section>
  );
}